import { DataActiveStatusEnum } from "../Category/types";

export interface IData {
  _id: string;
  title: string;
  status: DataActiveStatusEnum;
  groupId: string;
  packageId: string;
  packageTitle: string;
  groupTitle:string
  allergicImages: IImages[];
  featuredImage: string;
  createdAt: string;
  updatedAt: string;
}
export interface IImages {
  _id: string;
  file: string;
  isRemove: boolean;
}

export enum ProductType {
  Null = "Null",
  SINGLE = "Individual Item",
  PACKAGE = "Package Item",
}

export interface GroupProductState {
  formData: IData;
  list: IData[];
  allList: IData[];
  allGroupList: IData[];
  loading: boolean;
  buttonLoading: boolean;
  search: string;
  pageNo: number;
  pageSize: number;
  totalRow: number;
  orderBy: string;
  orderDir: string;
  toggleLoading: boolean;
}

export type InitialState = GroupProductState;
